import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly prefix = 'complydome';

  private normalizeKey(key: string): string {
    key = key.replace(/[^a-zA-Z0-9]/g, '');
    key = key.toLowerCase();

    return this.prefix ? `${this.prefix}:${key}` : key;
  }

  setValue(key: string, value: any): void {
    key = this.normalizeKey(key);

    if (value === undefined) {
      localStorage.removeItem(key);
      return;
    }

    localStorage.setItem(key, JSON.stringify(value));
  }

  getValue(key: string): any {
    key = this.normalizeKey(key);
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  removeValue(key: string): void {
    key = this.normalizeKey(key);
    localStorage.removeItem(key);
  }

  clear() {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.indexOf(this.prefix) === 0) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.map(key => {
      localStorage.removeItem(key)
    })
  }

  setClientId(clientId: string): void {
    this.setValue('client_id', clientId);
  }

  getClientId(): string {
    return this.getValue('client_id') || '';
  }

  clearClientId(): void {
    this.removeValue('client_id');
  }
}
